var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9998 12.8571C3.81722 12.8571 2.85693 13.8174 2.85693 14.9999C2.85693 16.1825 3.81722 17.1428 4.9998 17.1428C6.18237 17.1428 7.14266 16.1825 7.14266 14.9999C7.14266 13.8174 6.18237 12.8571 4.9998 12.8571ZM4.9998 14.2857C5.39409 14.2857 5.71408 14.6057 5.71408 14.9999C5.71408 15.3942 5.39409 15.7142 4.9998 15.7142C4.6055 15.7142 4.28551 15.3942 4.28551 14.9999C4.28551 14.6057 4.6055 14.2857 4.9998 14.2857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28564 5.7142V13.5714C4.28564 13.9656 4.60564 14.2856 4.99993 14.2856C5.39423 14.2856 5.71422 13.9656 5.71422 13.5714V5.7142C5.71422 5.3199 5.39423 4.99991 4.99993 4.99991C4.60564 4.99991 4.28564 5.3199 4.28564 5.7142Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99985 18.5714C3.0287 18.5714 1.42841 16.9711 1.42841 14.9999C1.42841 13.9432 1.8887 12.9931 2.61911 12.3389C2.77058 12.2032 2.85699 12.0097 2.85699 11.8067V3.57118C2.85699 2.3886 3.81728 1.42832 4.99985 1.42832C6.18243 1.42832 7.14272 2.3886 7.14272 3.57118V11.8067C7.14272 12.0095 7.22913 12.2031 7.3806 12.3389C8.11101 12.9932 8.5713 13.9432 8.5713 14.9999C8.5713 16.0567 8.11101 17.0071 7.3806 17.661C7.08659 17.9242 7.06204 18.3759 7.32495 18.6696C7.58787 18.9636 8.03989 18.9885 8.33357 18.7252C9.35639 17.8095 10 16.4792 10 14.9999C10 13.6388 9.45504 12.4038 8.57145 11.5017V3.57144C8.57145 1.60029 6.97116 0 5.00001 0C3.02886 0 1.42857 1.60029 1.42857 3.57144V11.5021C0.544981 12.4039 0 13.6389 0 15C0 17.7595 2.24045 20 5.00001 20C5.39431 20 5.7143 19.68 5.7143 19.2857C5.7143 18.8914 5.39431 18.5714 5.00001 18.5714L4.99985 18.5714Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2859 1.42847H12.143C11.7487 1.42847 11.4287 1.74846 11.4287 2.14275C11.4287 2.53705 11.7487 2.85704 12.143 2.85704H14.2859C14.6802 2.85704 15.0001 2.53705 15.0001 2.14275C15.0001 1.74846 14.6802 1.42847 14.2859 1.42847Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4287 4.99991H12.143C11.7487 4.99991 11.4287 5.3199 11.4287 5.7142C11.4287 6.10849 11.7487 6.42848 12.143 6.42848H16.4287C16.823 6.42848 17.143 6.10849 17.143 5.7142C17.143 5.3199 16.823 4.99991 16.4287 4.99991Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4287 12.1428H12.143C11.7487 12.1428 11.4287 12.4628 11.4287 12.8571C11.4287 13.2514 11.7487 13.5714 12.143 13.5714H16.4287C16.823 13.5714 17.143 13.2514 17.143 12.8571C17.143 12.4628 16.823 12.1428 16.4287 12.1428Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2859 8.57135H12.143C11.7487 8.57135 11.4287 8.89134 11.4287 9.28564C11.4287 9.67993 11.7487 9.99992 12.143 9.99992H14.2859C14.6802 9.99992 15.0001 9.67993 15.0001 9.28564C15.0001 8.89134 14.6802 8.57135 14.2859 8.57135Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.d39fce45f5acd1df4b02fc38003966e1.svg";
export { ForwardRef as ReactComponent };